import { isEmpty, isNumber } from "lodash";
import { useState } from "react";
import { useContextSelector } from "use-context-selector";
import BetSlipContext from "../../context/BetSlipContext";
import { AnimatePresence, motion } from "framer-motion";
import { useTabIndicator } from "../../component/useTabIndicator";
import { useFancyLogic } from "../useLogic/useFancyLogic";
import { isMobile } from "react-device-detect";

const Fancy = ({
  fancy,
  detail,
  profileData,
  position,
  addToFavioute,
  favouriteList,
  fancyHeader,
  setFancyModal,
}) => {
  const [fancyHeaderKey, setFancyHeaderKey] = useState("All");
  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });

  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });
  const { data, localLimit, handelChange, mergeAndCalculate } = useFancyLogic({
    fancy,
    detail,
    profileData,
    favouriteList,
    fancyHeaderKey,
  });

  const { containerRef, setActiveIndex, indicatorStyle } = useTabIndicator(0);

  return (
    <>
      <div
        data-v-147800cd
        style={{
          "--18063ecc": `${indicatorStyle?.width || (isMobile ? 41 : 54)}px`,
          "--21b4db84": `translateX(${
            indicatorStyle?.x || (isMobile ? 3 : 4.6)
          }px)`,
        }}
        className="s-flex s-items-center s-bg-market-tab-bg-active s-text-market-tab-text-active s-pl-1.5 s-pt-px"
      >
        <div data-v-147800cd className="s-overflow-x-scroll s-mr-2 s--ml-0.5">
          <div data-v-147800cd className="s-relative s-inline-block">
            <div
              ref={containerRef}
              data-v-147800cd
              className="s-w-full s-h-30px s-flex s-justify-center"
            >
              {fancyHeader?.map((res, index) => {
                return (
                  <div
                    onClick={() => {
                      setFancyHeaderKey(res?.type);
                      setActiveIndex(index);
                    }}
                    data-v-147800cd
                    name={res?.name}
                    className="s-text-14px s-font-bold s-py-2 s-px-4 s-mx-1 s-mt-px s-text-center s-text-market-sub-text"
                  >
                    {res?.name}
                  </div>
                );
              })}

              <motion.div
                data-v-147800cd
                className="tab-indicator s-absolute s-left-0 s-bottom-1 s-h-3px s-rounded-1.5px s-bg-market-sub-text"
              />
            </div>
          </div>
        </div>
        <div
          data-v-147800cd
          className="s-icon-info-circle s-block s-w-16px s-h-16px s-ml-auto s-mr-2 s-text-16px s-text-market-sub-text s-opacity-25 dark:s-opacity-45"
        />
      </div>
      <div className="s-rounded-b-lg">
        {data?.length > 0 ? (
          <div className="s-bg-white dark:s-bg-black-800 s-rounded-b-5px s-px-3px s-pb-3px">
            <div className="s-py-1px s-flex s-justify-between s-items-center">
              <div className="s-flex-1" />
              <div className="s-w-129px s-flex s-gap-1px s-text-14px s-font-bold s-leading-140">
                <div className="s-w-64px s-text-center s-text-global-font-default-light dark:s-text-global-font-default-dark">
                  No
                </div>
                <div className="s-w-64px s-text-center s-text-global-font-default-light dark:s-text-global-font-default-dark">
                  Yes
                </div>
              </div>
            </div>

            <div className="s-divide-y s-divide-black-100 dark:s-divide-black-900">
              {data?.map((item, index) => {
                if (
                  item?.odds?.ms == 4 ||
                  item?.odds?.rt?.length == 0 ||
                  item?.odds?.ms == 2 ||
                  isEmpty(item?.odds?.rt)
                ) {
                  return null;
                } else {
                  let findPosition = position?.find((res) => {
                    return res?.selectionId == item?.selectionId;
                  });
                  let oldPosition = !isEmpty(findPosition)
                    ? findPosition?.position
                    : "";

                  let newPosition = "";
                  if (oldPosition && position) {
                    let oldPositionData = findPosition || [];

                    if (
                      betSlipObject?.teamName === item?.name &&
                      showBetDialog
                    ) {
                      betSlipObject.betType = betSlipObject?.object?.ib
                        ? "Yes"
                        : "No";

                      newPosition =
                        oldPositionData && oldPositionData?.betRunPosition
                          ? mergeAndCalculate(betSlipObject, oldPositionData)
                          : 0;
                    }
                  } else {
                    if (
                      betSlipObject?.teamName === item?.name &&
                      showBetDialog
                    ) {
                      if (betSlipObject?.object?.ib) {
                        if (Math.abs(item?.position) > 0) {
                          let backLoss =
                            Number(betSlipObject?.bidPrice) +
                            Number(item?.position);
                          newPosition = backLoss;
                        } else {
                          let backLoss = Number(betSlipObject?.bidPrice);
                          newPosition = backLoss;
                        }
                      } else {
                        if (Math.abs(item?.position) > 0) {
                          let backProfit =
                            (betSlipObject?.bidPrice *
                              betSlipObject?.object?.pt) /
                            100;
                          newPosition =
                            Number(backProfit) + Number(item.position);
                        } else {
                          let backProfit =
                            (betSlipObject?.bidPrice *
                              betSlipObject?.object?.pt) /
                            100;
                          newPosition = backProfit;
                        }
                      }
                    }
                  }

                  let condition =
                    betSlipObject?.tamName === item?.name &&
                    Math.abs(newPosition) >= 0;
                  let animate = favouriteList?.includes(
                    String(item?.selectionId)
                  );
                  return (
                    <AnimatePresence>
                      <motion.div
                        key={item.selectionId}
                        layout={animate} // Animate only clicked item
                        initial={animate ? { opacity: 0, y: 5 } : false}
                        animate={animate ? { opacity: 1, y: 0 } : {}}
                        exit={{ opacity: 0 }}
                        transition={{
                          type: "spring",
                          stiffness: 500,
                          damping: 20,
                          mass: 0.5,
                        }}
                        className="s-relative"
                      >
                        <div className="s-flex s-justify-start s-items-center s-bg-black-100 dark:s-bg-black-700">
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              addToFavioute(
                                detail?.eventId,
                                "Fancy",
                                item?.selectionId
                              );
                            }}
                            data-v-5460a16b
                            className="s-fav s-text-global-font-default-light dark:s-text-global-font-default-dark s-text-15px s-ml-7px"
                          >
                            <div
                              data-v-5460a16b
                              className={`s-relative s-icon-star${
                                animate ? "-solid s-animate-star-line-box" : ""
                              }`}
                            >
                              <span
                                data-v-5460a16b
                                className={`s-rating-star-line s-bg-global-font-default-light dark:s-bg-global-font-default-dark ${
                                  animate ? "s-animate-star-line" : ""
                                }`}
                              />
                              <span
                                data-v-5460a16b
                                className={`s-rating-star-line s-bg-global-font-default-light dark:s-bg-global-font-default-dark ${
                                  animate ? "s-animate-star-line" : ""
                                }`}
                              />
                              <span
                                data-v-5460a16b
                                className={`s-rating-star-line s-bg-global-font-default-light dark:s-bg-global-font-default-dark ${
                                  animate ? "s-animate-star-line" : ""
                                }`}
                              />
                            </div>
                          </div>
                          <div className="s-flex s-flex-col s-justify-center s-h-full s-text-14px s-px-2 s-flex-1 s-my-7px s-text-global-font-default-light dark:s-text-global-font-default-dark">
                            <div className="s-flex s-flex-row">
                              <p className="s-flex-1 s-m-auto s-text-17px s-font-bold s-leading-120 s-break-words">
                                {item?.name}
                              </p>

                              {!isEmpty(findPosition) && (
                                <div
                                  onClick={() =>
                                    setFancyModal({
                                      status: true,
                                      object: {
                                        ...item,
                                        match: detail?.eventName,
                                        prevPosition: isNumber(oldPosition),
                                      },
                                    })
                                  }
                                  className="s-text-global-font-on-dark s-rounded-3px s-p-5px s-text-12px s-h-min s-font-normal s-bg-black-600 dark:s-bg-secondary s-ml-7px"
                                  data-testid="books-btn"
                                >
                                  <div className="s-visible">Book</div>
                                </div>
                              )}
                            </div>
                            {(isNumber(oldPosition) || condition) && (
                              <div
                                className="s-text-12px s-leading-150 s-flex"
                                data-testid="forecast"
                              >
                                {isNumber(oldPosition) &&
                                  Math.abs(item?.position) > 0 && (
                                    <span
                                      className="s-flex s-items-center s-text-forecast-down-text"
                                      data-testid="estimate-forecast"
                                    >
                                      {isNumber(oldPosition)
                                        ? `( ${Math?.abs(
                                            item?.position
                                          ).toFixed(2)} )`
                                        : ""}
                                    </span>
                                  )}
                                {betSlipObject?.teamName === item?.name &&
                                  Math.abs(newPosition) >= 0 && (
                                    <span
                                      className="s-flex s-items-center s-text-forecast-down-text"
                                      data-testid="estimate-forecast"
                                    >
                                      <span className="s-icon-arrow-left s-rotate-180 s-flex s-text-6px s-mx-0.5" />
                                      {`( ${Math.abs(newPosition).toFixed(
                                        2
                                      )} )`}
                                    </span>
                                  )}
                              </div>
                            )}
                          </div>
                          <div className="s-w-129px s-relative s-grid s-gap-1px s-grid-cols-2 s-self-start dark:s-text-black-900">
                            <div
                              title={
                                item?.odds?.rt?.length > 0
                                  ? item?.odds?.rt[0]?.rt
                                  : ""
                              }
                              id={"lay_odds_fancy_" + index}
                              onClick={(e) => {
                                {
                                  handelChange(
                                    item?.odds?.rt[0],
                                    "No",
                                    item?.name,
                                    item,
                                    e
                                  );
                                }
                              }}
                              data-v-ebc3700d
                              className={`s-pt-2 s-pb-5px s-text-center s-rounded-3px s-min-h-48px s-flex s-flex-col s-justify-center s-relative s-overflow-hidden s-bg-lay-300 dark:s-bg-lay-400-dark ${
                                Number(
                                  document.getElementById(
                                    "lay_odds_fancy_" + index
                                  )?.title
                                ) !== item?.odds?.rt[0]?.rt
                                  ? "s-animate-spark-no"
                                  : ""
                              } ${
                                betSlipObject?.teamName == item?.name &&
                                betSlipObject?.odds == item?.odds?.rt[0]?.rt &&
                                showBetDialog &&
                                betSlipObject?.betType == "No"
                                  ? "no-active"
                                  : ""
                              }`}
                            >
                              <h3
                                data-v-ebc3700d
                                className="s-text-17px s-font-bold s-mb-2px s-leading-12px"
                              >
                                {item?.odds?.rt[0]?.rt || ""}
                              </h3>
                              <p
                                data-v-ebc3700d
                                className="s-text-11px s-h-10px s-leading-10px"
                              >
                                {item?.odds?.rt[0]?.pt || ""}
                              </p>
                            </div>
                            <div
                              title={
                                item?.odds?.rt?.length > 0
                                  ? item?.odds?.rt[1]?.rt
                                  : ""
                              }
                              id={"back_odds_fancy_" + index}
                              onClick={(e) => {
                                {
                                  handelChange(
                                    item?.odds?.rt[1],
                                    "Yes",
                                    item?.name,
                                    item,
                                    e
                                  );
                                }
                              }}
                              data-v-ebc3700d
                              className={`s-pt-2 s-pb-5px s-text-center s-rounded-3px s-min-h-48px s-flex s-flex-col s-justify-center s-relative s-overflow-hidden s-bg-back-300 dark:s-bg-back-400-dark ${
                                Number(
                                  document.getElementById(
                                    "back_odds_fancy_" + index
                                  )?.title
                                ) !== item?.odds?.rt[1]?.rt
                                  ? "s-animate-spark-yes"
                                  : ""
                              } ${
                                betSlipObject?.teamName == item?.name &&
                                betSlipObject?.odds == item?.odds?.rt[1]?.rt &&
                                showBetDialog &&
                                betSlipObject?.betType == "Yes"
                                  ? "yes-active"
                                  : ""
                              }`}
                            >
                              <h3
                                data-v-ebc3700d
                                className="s-text-17px s-font-bold s-mb-2px s-leading-12px"
                              >
                                {item?.odds?.rt[1]?.rt || ""}
                              </h3>
                              <p
                                data-v-ebc3700d
                                className="s-text-11px s-h-10px s-leading-10px"
                              >
                                {item?.odds?.rt[1]?.pt || ""}
                              </p>
                            </div>
                            {(item?.odds?.ms == 9 ||
                              item?.odds?.ms == 2 ||
                              item?.odds?.ms == 3 ||
                              item?.odds?.ms == 4) && (
                              <div
                                className="s-absolute s-right-0 s-top-0 s-flex s-justify-center s-items-center s-w-full s-h-full s-bg-black-700 dark:s-bg-black-900 s-opacity-80 s-text-15px s-text-white s-rounded-3px s-z-20"
                                data-testid="fancybet-market-status"
                              >
                                Suspended
                              </div>
                            )}
                          </div>
                        </div>
                      </motion.div>
                    </AnimatePresence>
                  );
                }
              })}
            </div>
          </div>
        ) : (
          detail?.hasFancy && (
            <div class="s-bg-white s-rounded-b-xl dark:s-bg-market-tab-bg-active">
              <div class="s-bg-market-tab-active s-h-3px"></div>
              <div class="s-py-3 s-px-4 s-text-14px dark:s-text-black-500">
                Loading Market…
              </div>
            </div>
          )
        )}
      </div>{" "}
    </>
  );
};

export default Fancy;
